<template lang="pug">
.delete-confirmation-details
  .text-lg.font-medium {{ $t('delete_confirmation', { text: $t('item').toLowerCase() }) }}
    v-card.round-md.pa-4.mt-4(v-if="selectedTreatment" outlined color="neutral300")
      .text-md.font-semibold {{ selectedTreatment.name }}
      .text-sm {{ $t('quantity') }} : {{ selectedTreatment.quantity }}
      .text-sm(v-if="selectedTreatment.extra_data.price_tier_name") {{ $t('price_tier') }} : {{ selectedTreatment.extra_data.price_tier_name }}
      .text-sm {{ $t('rate') }} : {{ selectedTreatment.totalPrice | displayPrice }}
    .text-md.mt-4 {{ $t('item_delete_confirmation_description_primary', { item: $t('item') }) }}
    .text-md {{ $t('item_delete_confirmation_description_secondary') }}
</template>

<script>
export default {
  props: {
    selectedTreatment: {
      type: Object,
      default: null
    }
  }
};
</script>

<style lang="scss" scoped>
</style>